import { Tooltip } from 'antd';
import { orderBy } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { ContainerPontos } from './styled';

//APP
import { leadZero } from '../../../../../../../../../../../../utils';
import type { GeoPointFeature } from '../../../../types';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom';


interface Props {
    initialPoints: GeoPointFeature[]
    inserirPontosSelecionados: (pontos: GeoPointFeature[], id: string | number, cod_analise: number) => void
    id: string | number
    cod_analise: number
    removerPonto: (analiseId: string | number, pontoNome: number | string) => void
    /** Sem permissão de exclusão o ponto não pode ser removido. */
    podeRemover?: boolean
    /** Desabilita a edição (enquanto o modal de nova análise não foi migrado). */
    disabledInserir?: boolean
}

/** Grade de "chips" com os pontos de uma análise + botão para editar a seleção. */
export function PontosAnalises({ initialPoints = [], inserirPontosSelecionados, id, cod_analise, removerPonto, disabledInserir, podeRemover = true }: Props) {

    const lista_pontos_ordenados = orderBy(initialPoints, 'NOME');

    return (
        <ContainerPontos>
            <h3 className='points-title'>Pontos</h3>

            <div className='points-grid'>
                {lista_pontos_ordenados.map((point, index) => (
                    <div key={index} className='point-card' style={{ backgroundColor: point?.COR ?? undefined }}>
                        {leadZero(point?.NOME)}
                        {/* Sem permissão o botão fica desabilitado, não oculto — o
                            `title` explica o motivo ao passar o mouse. */}
                        <button
                            className='point-card__remove'
                            onClick={(e) => {
                                e.stopPropagation()
                                if (!podeRemover) return
                                removerPonto(id, point?.NOME)
                            }}
                            disabled={!podeRemover}
                            title={podeRemover ? 'Remover ponto' : 'Você não tem permissão para remover pontos. Solicite ao administrador.'}
                        >
                            <FontAwesomeIcon icon={faXmark} style={{ fontSize: 10 }} />
                        </button>
                    </div>
                ))}

                <Tooltip title="Inserir ponto ou editar pontos"><samp>
                    <ButtonCustom
                        style={{ height: 35, textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}
                        type='secondary'
                        onClick={() => inserirPontosSelecionados(initialPoints, id, cod_analise)}
                        icon={<FontAwesomeIcon icon={faPlus} />}
                        disabled={disabledInserir}
                    />
                </samp></Tooltip>
            </div>
        </ContainerPontos>
    )
};